import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { eventPlatformApi, type PlatformDashboard } from '../../api/eventplatform';

const NAV = [
  { to: '/events/stream', label: 'Live Stream' },
  { to: '/events/explorer', label: 'Event Explorer' },
  { to: '/events/registry', label: 'Schema Registry' },
  { to: '/events/queues', label: 'Queue Monitor' },
  { to: '/events/dead-letter', label: 'Dead Letter' },
  { to: '/events/replay', label: 'Replay Manager' },
  { to: '/events/messaging', label: 'Messaging Reliability' },
  { to: '/events/commerce', label: 'Commerce Catalog' },
];

export function EventHubPage() {
  const [dashboard, setDashboard] = useState<PlatformDashboard | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    void eventPlatformApi.dashboard().then(setDashboard).catch((e) => setError(String(e)));
  }, []);

  const stats = dashboard
    ? [
        { label: 'Total events', value: dashboard.total_events },
        { label: 'Queue depth', value: dashboard.queue_depth },
        { label: 'Pending outbox', value: dashboard.pending_outbox },
        { label: 'DLQ count', value: dashboard.dlq_count },
        { label: 'Registry entries', value: dashboard.registry_count },
        { label: 'Publishers', value: dashboard.publisher_count },
        { label: 'Consumers', value: dashboard.consumer_count },
      ]
    : [];

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold">Event Platform</h1>
      <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">
        Enterprise event bus, message broker and cross-module communication.
      </p>
      <nav className="mt-4 flex flex-wrap gap-3 text-sm">
        {NAV.map((l) => (
          <Link key={l.to} to={l.to} className="text-slate-700 hover:underline dark:text-slate-300">{l.label}</Link>
        ))}
      </nav>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-5">
        {stats.map((s) => (
          <div key={s.label} className="rounded-xl border bg-white p-4 dark:border-slate-700 dark:bg-slate-900">
            <p className="text-sm text-slate-500">{s.label}</p>
            <p className="mt-1 text-2xl font-semibold">{String(s.value ?? 0)}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
